enum Stores {
    US = 'us-store',
    CA = 'ca-store',
}

export { Stores };
